// de_pms_night_audit.ts
// Tłumaczenia dla PMS.NightAudit.tsx

export const dePmsNightAudit = {

  title: "Nachtaudit",

  // ── Sekcje ───────────────────────────────────────────────────────────────
  sections: {
    roomTaxPosting:      "Übersicht Zimmer- und Steuerbuchungen",
    openBalances:        "Übersicht offener Salden",
    noShowHandling:      "No-Show-Bearbeitung",
    overstayExceptions:  "Ausnahmen: verlängerte / verkürzte Aufenthalte",
    rateIntegrity:       "Ratenintegrität / Ausreißer",
    housekeepingSummary: "Housekeeping- / Zimmerverfügbarkeitsübersicht",
    finalControl:        "Abschlusskontrolle",
  },

  // ── Przyciski ─────────────────────────────────────────────────────────────
  actions: {
    closeDay:      "Tagesabschluss durchführen",
    closing:       "Wird abgeschlossen...",
    opening:       "Wird geöffnet...",
    createInvoice: "Rechnung erstellen",
    creating:      "Wird erstellt...",
    downloadPDF:   "PDF herunterladen",
    previewPDF:    "PDF-Vorschau",
    saving:        "Wird gespeichert...",
  },

  // ── Etykiety ──────────────────────────────────────────────────────────────
  labels: {
    invoice:          "Rechnung",
    fiscalizedInvoice:"Fiskalisierte Rechnung",
    nightAuditFolio:  "Nachtaudit-Folio",
    noFolioSelected:  "Kein Folio ausgewählt",
    rateOutlier:      "DLX-Preis-Ausreißer",
  },

  // ── Komunikaty ────────────────────────────────────────────────────────────
  messages: {
    invoiceFailed: "Rechnungserstellung fehlgeschlagen.",
  },

} as const;

export default dePmsNightAudit;
